import React, { useContext } from 'react'
import ItemHijo from './ItemHijo'
import GeneralContext from '../../context/GeneralContext'

//Services
import * as Services from '../../utils/services'

const Hijo = ({ state, setState, familiares, producto }) => {
    const { state: generalState } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const recargarListaHijos = async () => {
        try {
            setState((state) => {
                return {
                    ...state,
                    estaCargando: true
                }
            })
            const resFamiliares = await Services.getFamiliares(user, cotizacion.idSolicitudMultiple)
            if (!resFamiliares.error) {
                let hijos = {}
                if (resFamiliares.res.length > 0) {
                    hijos = resFamiliares.res.filter((familia) => familia.parentesco.codigo !== 1)
                }
                setState((state) => {
                    return {
                        ...state,
                        listaFamiliares: hijos,
                        estaCargando: false,
                        reloadValidacion: false,
                        errorCargando: null
                    }
                })
            } else {
                setState((state) => {
                    return {
                        ...state,
                        estaCargando: false,
                        errorCargando: resFamiliares.mensajeError
                    }
                })
            }
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <React.Fragment>
            <ItemHijo
                state={state}
                setState={setState}
                family={familiares}
                pFamilia={producto}
                recargarLista={recargarListaHijos}
            />
        </React.Fragment>
    )
}

export default Hijo